import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import { MarginQuarterOptions, MarginQuarterValue, MarginRequest } from '../../RiskDefinitions';

interface IStartingQuarterDropdownProps {
    marginRequest: MarginRequest;
    handleSetStartingQuarter: (marginQuarterValue: MarginQuarterValue) => void;
    quarterOptions: MarginQuarterOptions[];
    disabled?: boolean;
}

const StartingQuarterDropdown = (props: IStartingQuarterDropdownProps) => {
    const [translations] = useLanguage();

    return (
        <div>
            <Dropdown
                testId="StartingQuarterDropdown"
                value={props.marginRequest.startingQuarter}
                options={props.quarterOptions}
                handleOptionChange={(value) => props.handleSetStartingQuarter(value)}
                label={translations.risk.margin.fields.startingQuarter}
                disabled={props.disabled}
                track={{ eventCategory: 'MarginCalculator', eventAction: 'StartingQuarterChanged' }}
            />
        </div>
    );
};

export default StartingQuarterDropdown;
